import React from 'react';

import { ItemGroupProps } from 'types/ItemGroupProps';
import * as S from './styles';

interface SingleBannerProps {
  data: ItemGroupProps;
  phoneWidth: number;
}

export default function SingleBanner({ data, phoneWidth }: SingleBannerProps) {
  return (
    <S.container>
      {data?.items[0]?.file?.url ? (
        <img src={data?.items[0]?.file?.url} alt={data.name} />
      ) : (
        <p>No image</p>
      )}
    </S.container>
  );
}
